import React, { createContext, useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import { useLocation } from "react-router-dom";

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  const location = useLocation();

  useEffect(() => {

    const unsubscribe = onAuthStateChanged(auth, async (user) => {

      if (location.pathname.includes("/rejestracja")) {
        setLoading(false);
        return;
      }

      setLoading(true);
      if (user) {

        setCurrentUser(user);

        const docRef = doc(db, "personel", user.uid);
        const docSnap = await getDoc(docRef);
        
        if (docSnap.exists()) {
          const data = docSnap.data();
          setRole(data.role || "null");
        } else {
          setRole("user");
        }
      } else {
        setCurrentUser(null);
        setRole(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const value = { currentUser, role, loading };
  return (
    <AuthContext.Provider value={value}>
      {loading ? 
        <div style={({display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "100%", gap: "15px", position: "fixed", top: "0px", left: "0px", minHeight: "100vh", zIndex: "5", backgroundColor: "rgb(250,250,250)"})}>
          <div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
          <h3 style={({fontSize: "18px", color: "rgb(20,20,20)"})}>Ładowanie...</h3>
        </div>   
      : 
        children
      }
    </AuthContext.Provider>
  );
}